import { inject, Injectable } from '@angular/core';
import type { ErrorLogService, StatsdService } from '@app/interface/common.interface';

import type { LoadContext } from './iris.interface';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import type { IJobStore } from '@app/interface/job/job-store.interface';

@Injectable({
  providedIn: 'root'
})
export class IrisMetricsReporter {
  static readonly IMAGE_RENDER_SUCCESS_COUNTER = 'IMAGE_RENDER_SUCCESS';
  static readonly IMAGE_RENDER_FAILED_COUNTER = 'IMAGE_RENDER_FAILED';
  static readonly IMAGE_RETRIEVED_SUCCESS_COUNTER = 'IMAGE_RETRIEVED_SUCCESS';
  static readonly IMAGE_RETRIEVE_FAILURE_COUNTER = 'IMAGE_RETRIEVE_FAILURE';

  statsdService: StatsdService = inject<StatsdService>(angularjs.StatsdService);
  errorLogService: ErrorLogService = inject<ErrorLogService>(angularjs.ErrorLogService);
  jobStore: IJobStore = inject<IJobStore>(angularjs.JobStore);

  reportSuccess(loadContext: LoadContext): void {
    this.statsdService.logImageRenderSuccessTime(new Date().getTime() - loadContext.startTime.getTime());
    this.statsdService.incrementCounter(IrisMetricsReporter.IMAGE_RENDER_SUCCESS_COUNTER);
  }

  reportFailure(loadContext: LoadContext, reason: string): void {
    this.statsdService.logImageRenderFailureTime(new Date().getTime() - loadContext.startTime.getTime());
    this.statsdService.incrementCounter(IrisMetricsReporter.IMAGE_RENDER_FAILED_COUNTER);

    const errorMessage = `Image Status Failed \
      accessCode: ${loadContext.job.accessCode}; \
      portraitId: ${loadContext.job.portraitId}; \
      lookNumber: ${loadContext.lookNumber}; \
      captureSessionId: ${this.jobStore.getCaptureSessionId(loadContext.job.jobKey)}; \
      reason: ${reason};`;

    this.errorLogService(errorMessage);
  }

  logImageLoadSuccess(): void {
    this.statsdService.incrementCounter(IrisMetricsReporter.IMAGE_RETRIEVED_SUCCESS_COUNTER);
  }

  logImageLoadFailure(): void {
    this.statsdService.incrementCounter(IrisMetricsReporter.IMAGE_RETRIEVE_FAILURE_COUNTER);
  }
}
